<style lang="stylus">
        .ft-floaticon
            position relative
            height 52px
            min-width 32px

            .ft-icon
                position relative
                floatTool_icon()
                svg
                    &:focus
                        outline: none;
                    &.styleBrush
                        color: var(--svg-color-primary-secondary);
                    &.quick, &.replaceImg,&.crop,&.shapeCrop,&.float-img-reset,&.intersect,&.subtract,
                    &.batchReplaceImg,&.org-hideImg,&.org-showImg,&.mm-line,&.mm-pic,
                    &.table-deleteTable,
                    &.gantt-float-column,&.editDig,&.swimline-main-title,&.ft-size,&.mm-line-style
                        fill: var(--svg-color-gray-75-secondary);
                        color: var(--svg-color-gray-42-secondary);
                    &.replace, &.back-layer, &.front-layer,&.clear-mark,&.org-card,
                    &.org-insert,&.org-layout,&.org-select,&.float-more,&.mm-subtopic,
                    &.float-linestyle,&.float-lineanimate,&.float-lineweight,&.mm-summary,&.mm-boundary,&.mm-insert,&.mm-float-layout,
                    &.mm-icon,&.mm-num,&.mm-beautify,&.mm-shape,&.mm-add,&.float-connector,&.float-fillcolor-arrow,
                    &.gantt-options,&.gantt-new-task,&.gantt-subtask,&.gantt-delete,&.gantt-task,&.gantt-theme,
                    &.refreshDig,&.showName,&.chart-type,&.chart-legend,&.dateTag,&.float-multiple-group,&.float-multiple-ungroup,
                    &.float-multiple-select,&.swimline-text-direction,&.swimline-direction,&.float-setting,&.echart-data-tag
                        color: var(--svg-color-gray-42-secondary);
                    &.replace-line
                        color: var(--svg-color-gray-42-secondary);
                        height 32px;
                        width 32px;
                    &.mm-boundaryShape, &.mm-summaryShape
                        color: var(--svg-color-primary-secondary);
                    &.gantt-add-column,&.gantt-float-column
                        width 25px;
                    &.timeline-hollow
                        fill: var(--svg-color-gray-d0);
                    &.table-insertCell,&.table-mergeCell,&.table-mergeCell,&.table-splitCell,&.gantt-add-column
                        color: var(--svg-color-gray-75-secondary);
                        stroke: var(--svg-color-gray-42-secondary);
                        fill: var(--svg-color-gray-d0);
                svg[class^='smartshape-'],svg[class^='timeline-']
                    color: var(--svg-color-gray-42-secondary);

                .ft-color
                    position absolute
                    top 22px
                    left 8px
                    height 3px
                    width 16px
                    border-radius 1.5px

                &.disabled
                    pointer-events none
                    filter opacity(0.5)
                &.disabled:hover
                    background var(--bg-color-white)
            .selectActive-container
                display flex
                width 40px
                .ft-arrow
                    &.active
                        background inherit
                        border-radius 2px
                        height 28px
                        display flex
                        align-items center
                .ft-arrow
                    margin-left 2px
                    svg
                        width 8px;
                        height 8px;
                        color: var(--svg-color-gray-75-secondary)
            .ft-text
                floatTool_text()

                &.disabled
                    filter opacity(0.5)
                    pointer-events none

            .ft-floatbox
                position absolute
                top 64px
                left 0
                background $ft-bgcolor
                box-shadow $ft-boxshadow
                border-radius $ft-boxradius

    .floattrans-enter-active,
    .floattrans-leave-active
        transition opacity .3s
    .floattrans-enter,
    .floattrans-leave-to
        opacity 0
</style>

<template>
    <div class="ft-floaticon" ref="floatbox">
        <div
            class="ft-icon"
            :class="{
                active: value || (useExpand && show) || isActive || (hasSelectActive && show),
                disabled: disable,
                'selectActive-container': hasSelectActive,
            }"
            @click="clickIcon"
        >
            <template v-if="imgIcon && imgIcon.includes('/img/')">
                <img :src="imgIcon" draggable="false" @dragstart.prevent alt="" :content="tips" v-tippy="{ placement: tipsPosition }" />
            </template>
            <template v-else>
                <iconSymbol
                    :class="imgIcon"
                    :name="imgIcon"
                    draggable="false"
                    @dragstart.native.prevent
                    :content="tips"
                    v-tippy="{ placement: tipsPosition }"
                />
            </template>
            <div v-if="showColor" class="ft-color" :style="{ background: color || '#000000' }"></div>
            <div class="ft-arrow" :class="{ active: show }" v-if="hasSelectActive" @click.stop="clickArrowIcon">
                <iconSymbol class="selectActive-icon" name="float-triangle" draggable="false" @dragstart.native.prevent />
            </div>
        </div>
        <div class="ft-text" :class="{ disabled: disable }">
            <p>{{ text }}</p>
        </div>
        <transition name="floattrans">
            <div class="ft-floatbox" ref="expandBox" v-if="!noRenderChild" v-show="show" @mousedown="expandFunc('select', '', $event)">
                <slot name="content" />
            </div>
        </transition>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Expander from "@/app/utils/expander.js";
    import { floatPopPositonFit } from "../positionfit";

    @Component
    export default class FloatIcon extends Vue {
        @Prop({ default: "unknow" }) // 同一组件内多次使用，区分点击icon事件
        iconName;
        @Prop() // icon
        imgIcon;
        @Prop() // icon底部描述文本
        text;
        @Prop() // 单icon时使用，绑定icon激活态(如加粗、斜体等)
        value;
        @Prop() // 有对应展开菜单时使用
        useExpand;
        @Prop({ default: false }) // 填充色专用
        showColor;
        @Prop() // 填充色专用
        color;
        @Prop()
        disable;
        @Prop()
        tips;
        @Prop({ default: "top" })
        tipsPosition;

        @Prop()
        hasSelectActive; // 不同的选中

        @Prop({ default: false })
        isChart; // 是图表类型的浮动
        @Prop({ default: false })
        isActive;
        @Prop()
        noRenderChild;

        @Inject()
        ["getFloatRootDom"];

        show = false;
        expander = null;
        floatPopPositonFit = null;

        get isLock() {
            return this.$store.state.floatTool.floatToolLock;
        }

        clickIcon(e) {
            if (this.useExpand) {
                this.expandFunc("expand", "", e);
                this.$emit("clickIcon");
            } else {
                this.$emit("clickIcon", { key: this.iconName });
                if (this.isChart) {
                    this.$emit("showDigital");
                }
            }
        }

        clickArrowIcon(e) {
            this.expandFunc("expand", "", e);
        }

        getParentData() {
            const parentdom = this.getFloatRootDom();
            const rect: DOMRect = parentdom.getBoundingClientRect() as DOMRect;
            return {
                x: rect.x,
                y: rect.y,
                w: rect.width,
                h: rect.height,
            };
        }
        getChildData() {
            const childDom = (this.$refs.expandBox as HTMLElement).firstChild as HTMLElement;
            const rect: DOMRect = childDom.getBoundingClientRect() as DOMRect;
            return {
                x: rect.x,
                y: rect.y,
                w: rect.width,
                h: rect.height,
            };
        }
        initPosition() {
            this.$nextTick(() => {
                this.resetPosition();
                const childDom = (this.$refs.expandBox as HTMLElement)?.firstChild as HTMLElement;
                if (!childDom) return;
                const cData = this.getChildData(),
                    pData = this.getParentData();
                let iconPosition = cData.x > pData.x + pData.w / 2 ? 1 : 0;
                let position = this.floatPopPositonFit.checkLv1Position(pData, cData, iconPosition);
                let dom = this.$refs.expandBox as HTMLElement;
                let rootDom = this.$refs.floatbox as HTMLElement;
                const rect: DOMRect = rootDom.getBoundingClientRect() as DOMRect;
                dom.style.left = `${position[0] - rect.x}px`; // 参考系由页面转为rootdom
                dom.style.top = `${position[1] - rect.y}px`;
            });
        }
        resetPosition() {
            let dom = this.$refs.expandBox as HTMLElement;
            if (!dom) return;
            dom.style.left = `0px`;
            dom.style.top = `64px`;
        }

        expandFunc(type, args, ev) {
            if (!this.expander) {
                let dom = this.$refs.floatbox as HTMLElement;
                let expand = () => {
                    !this.show && this.$emit("expandTool", { key: this.iconName });
                    this.show = !this.show;
                    this.initPosition();
                    console.log("expand");
                };
                let select = (args) => {
                    // 点击内容区冒泡触发隐藏窗口
                    this.show = false;
                };
                let close = () => {
                    this.show = false;
                };
                this.expander = new Expander(dom, { expand: expand, select: select, close: close });
            }
            if (type == "expand") {
                this.expander.expand();
            } else if (type == "select") {
                this.expander.select(args);
            }
        }

        forceClose() {
            // 强制关闭弹窗
            this.expander && this.expander.fClose();
        }
        created() {}
        mounted() {
            this.floatPopPositonFit = floatPopPositonFit;
        }
    }
</script>
<i18n>
{
    "zh": {},
    "en": {},
    "fr": {},
    "de": {},
    "jp": {},
    "es": {},
    "pt": {},
    "it": {},
    "tw": {},
    "kr": {}
}
</i18n>
